export const apiRoutes = {
  auth: {
    login: "login",
    logout: "logout",
    changePassword: "change-password",
  },

  //Webiste
  webiste: {
    collegeRegister: "institution-request",
    mentorRequest: "mentor-request",
    services: "services",
    project: "projects",
    addProjectRequirements: "add-project-requirements",
    quizes: "quizes",
    quizDetails: "",
    kidsPrograms: "kids-programs",
    studentPrograms: "student-programs",
    programDetails: "programs-details/slug", // replace slug with original value
  },

  // Admin Routes
  logout: "logout",
  admin: {
    modules: "admin/modules",
    services: "admin/services",
    roadMap: "admin/road-maps",
    programs: "admin/programs",
    homeBanner: "admin/home-banner",
    mentorRequestList: "admin/mentor-request-list",
    institutionRequestList: "admin/institution-request-list",
    mentorRequestApproved: "admin/mentor-request-approved",
    institutionRequestApproved: "admin/institution-request-approved",
  },

  // Mentor
  mentor: {
    task: "tasks",
    mentorDashboard: "mentor-dashboard",
  },

  // Student
  student: {
    studentProfile: "student-profile",
    studentDashboard: "student-dashboard",
    studentAssessment: "student-assessment",
    studentSessions: "student-sessions",
  },
};
